<template>
  <v-text-field @click="checkBoxClick" readonly>
    <v-icon style="cursor: pointer">{{ getIcon }}</v-icon>
    <span style="cursor: pointer">{{ getText }}</span>
  </v-text-field>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: Boolean,
      default: null,
    },
    yesValue: {
      type: String,
      default: "",
    },
    noValue: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      val: this.modelValue,
    };
  },
  computed: {
    getIcon() {
      if (this.val == true) {
        return "mdi-checkbox-marked-outline";
      } else if (this.val == false) {
        return "mdi-checkbox-blank-outline";
      }
      return "mdi-checkbox-intermediate";
    },
    getText() {
      if (this.val == true) {
        return this.yesValue;
      } else if (this.val == false) {
        return this.noValue;
      }
      return "";
    },
  },
  methods: {
    checkBoxClick() {
      if (this.val == null) {
        this.val = true;
      } else if (this.val == true) {
        this.val = false;
      } else if (this.val == false) {
        this.val = null;
      }
      this.$emit("update:modelValue", this.val);
      this.$emit("change", this.val);
    },
  },
};
</script>

<style scoped>
* >>> input {
  cursor: pointer !important;
  text-align: center;
}
</style>